import type { AgentName, ProposalStatus } from './services/agent-proposals.service';

export const STATUS_LABELS: Record<ProposalStatus, string> = {
  PENDING: 'Pendente',
  APPROVED: 'Aprovada (executando)',
  REJECTED: 'Recusada',
  EXECUTED: 'Executada',
  FAILED: 'Falhou',
  EXPIRED: 'Vencida',
};

export const STATUS_TONES: Record<
  ProposalStatus,
  'neutral' | 'accent' | 'warning' | 'danger' | 'info'
> = {
  PENDING: 'warning',
  APPROVED: 'info',
  REJECTED: 'neutral',
  EXECUTED: 'accent',
  FAILED: 'danger',
  EXPIRED: 'neutral',
};

const AGENT_LABELS: Record<AgentName, string> = {
  nami: 'Nami (finanças)',
  zoro: 'Zoro (gestão)',
  brook: 'Brook (marketing)',
  luffy: 'Luffy',
};

const ACTION_LABELS: Record<string, string> = {
  'transacao.marcar_paga': 'Marcar transação como paga',
  'imposto.marcar_pago': 'Marcar imposto como pago',
  'transacao.categorizar': 'Categorizar transação',
  'template.criar': 'Criar template de e-mail',
  'campanha.criar_rascunho': 'Criar rascunho de campanha',
  'campanha.agendar': 'Agendar envio de campanha',
  'sinal.promover': 'Promover sinal a lead',
  'sinal.descartar': 'Descartar sinal',
  'regras.criar_lote': 'Criar ou ajustar regras de classificação',
  'importacao.classificar_lote': 'Classificar linhas pendentes da importação',
  'fechamento.finalizar': 'Fechar o mês',
  'fatura.classificar_itens': 'Classificar itens da fatura',
};

export function agentLabel(agent: string): string {
  return (AGENT_LABELS as Record<string, string>)[agent] ?? agent;
}

export function actionLabel(actionType: string): string {
  return ACTION_LABELS[actionType] ?? actionType;
}

export function formatDateTime(iso: string | null): string {
  if (!iso) {
    return '-';
  }
  return new Date(iso).toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    dateStyle: 'short',
    timeStyle: 'short',
  });
}
